<template>
  <v-combobox
    :value="value"
    :items="items"
    v-bind="{ ...$attrs, ...$props }"
    v-on="$listeners"
    clearable
    chips
    multiple
    deletable-chips
    outlined
    allow-overflow
  />
</template>

<script>
export default {
  name: 'ShopSettingsFieldMultiselect',
  props: {
    value: {
      type: [String, Array],
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
}
</script>
